export const PAGE_PADDING_SMALL = '16px';
export const PAGE_PADDING_MEDIUM = '64px';
export const PAGE_PADDING_LARGE = '108px';
export const CARD_MAX_WIDTH_1 = '420px';
export const CARD_GAP = '24px';
export const CARD_MIN_WIDTH = '280px';
export const THREE_COLUMN_BREAKPOINT_WITHOUT_SCROLLBAR =
  parseInt(CARD_MIN_WIDTH, 10) * 3 +
  parseInt(CARD_GAP, 10) * 2 +
  parseInt(PAGE_PADDING_LARGE, 10) * 2;
